import React from 'react';
import { render } from '@testing-library/react';
import { Select } from './Select';

describe('Select', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Select
				options={[
					{ key: 1, value: 1, text: 'Option 1' },
					{ key: 2, value: 2, text: 'Option 2' },
					{ key: 3, value: 3, text: 'Option 3' },
					{ key: 4, value: 4, text: 'Option 4' },
					{ key: 5, value: 5, text: 'Option 5' },
					{ key: 6, value: 6, text: 'Option 6' },
					{ key: 7, value: 7, text: 'Option 7' },
					{ key: 8, value: 8, text: 'Option 8' },
					{ key: 9, value: 9, text: 'Option 9' },
				]}
				placeholder="Choose Option"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
